import colors from '../foundational-styles/colors';
import fontFamilies from './fontFamilies';

/**
 * Heading styles.
 * @property {Object} headings.900
 * @property {Object} headings.800
 * @property {Object} headings.700
 * @property {Object} headings.600
 * @property {Object} headings.500 - Default.
 * @property {Object} headings.400
 * @property {Object} headings.300
 * @property {Object} headings.200
 * @property {Object} headings.100
 */
export default {
  '900': {
    fontSize: '35px',
    fontWeight: 500,
    lineHeight: '40px',
    letterSpacing: '-0.2px',
    marginTop: 52,
    fontFamily: fontFamilies.display,
    color: colors.text.dark
  },
  '800': {
    fontSize: '29px',
    fontWeight: 500,
    lineHeight: '32px',
    letterSpacing: '-0.2px',
    marginTop: 40,
    fontFamily: fontFamilies.display,
    color: colors.text.dark
  },
  '700': {
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: '28px',
    letterSpacing: '-0.07px',
    marginTop: 40,
    fontFamily: fontFamilies.display,
    color: colors.text.dark
  },
  '600': {
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '-0.07px',
    marginTop: 28,
    fontFamily: fontFamilies.display,
    color: colors.text.dark
  },
  '500': {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '-0.05px',
    marginTop: 24,
    fontFamily: fontFamilies.ui,
    color: colors.text.dark
  },
  '400': {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    letterSpacing: '-0.05px',
    marginTop: 16,
    fontFamily: fontFamilies.ui,
    color: colors.text.dark
  },
  '300': {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '16px',
    letterSpacing: '0',
    marginTop: 16,
    fontFamily: fontFamilies.ui,
    color: colors.text.dark
  },
  '200': {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '16px',
    marginTop: 16,
    fontFamily: fontFamilies.ui,
    color: colors.text.muted
  },
  '100': {
    fontSize: '11px',
    fontWeight: 400,
    textTransform: 'uppercase',
    lineHeight: '16px',
    letterSpacing: '0.6px',
    marginTop: 16,
    fontFamily: fontFamilies.ui,
    color: colors.text.muted
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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